import { Component } from '@angular/core';
import { AuthService } from '../../auth.service';
import { DadosService } from '../../services/dados.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent {

  public navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  private dados = {};


  constructor(protected authService: AuthService, private dadosService: DadosService) {
    this.navItems = this.gerarMenu();
    if (this.authService.isAdm) {
      this.changes = new MutationObserver((mutations) => {
        this.sidebarMinimized = document.body.classList.contains('sidebar-minimized')
      });

      this.changes.observe(<Element>this.element, {
        attributes: true
      });
    }

    this.dadosService.getByField('uid', this.authService.afAuth.auth.currentUser.uid).valueChanges().subscribe(res => this.dados = res);
  }

  logout() {
    this.authService.logout();
  }

  gerarMenu() {
    if (this.authService.isAdm()) {
      return [
        {
          name: 'Dashboard',
          url: '/dashboardadm',
          icon: 'icon-speedometer'
        },
        {
          name: 'Cursos',
          url: '/curso',
          icon: 'fa fa-graduation-cap',
          class: ""
        },
        {
          name: 'Materias',
          url: '/materias',
          icon: 'fa fa-graduation-cap',
          class: ""
        }
        ,
        {
          name: 'Nivel / aulas',
          url: '/nivel',
          icon: 'fa fa-video-camera',
          class: ""
        },
        {
          name: 'Vendedores',
          url: '/vendedor',
          icon: 'fa fa-users',
          class: ""
        },
        {
          name: 'Alunos',
          url: '/aluno',
          icon: 'fa fa-user',
          class: ""
        },
        {
          name: 'Obras',
          url: '/autor',
          icon: 'fa fa-book',
          class: ""
        },
        {
          name: 'Vestiba',
          url: '/vestiba',
          icon: 'fa fa-check-square-o',
          class: ""
        },
        {
          name: 'Banner',
          url: '/banner',
          icon: 'fa fa-flag',
          class: ""
        },      
        {
          name: 'Simulado',
          url: '/simulado',
          icon: 'fa fa-tags',
          class: ""
        }


      ];
    }
    return [];

  }



}
